import { News, Promotion, Menu, Contact } from "@/@types/index";
import { SlideResponse } from '../services/api/slider/models/SlideResponse';


export const _slides: SlideResponse[] = [
    {
        image: "https://acortar.link/QJXLkc",
        image_responsive: "https://acortar.link/QJXLkc",
        alt_text: "image_1",
        link: "linkExample",
        is_blank: "0",
        order: 1,
    },
    {

        image: "https://acortar.link/a6wo8s",

        image_responsive: "https://acortar.link/QJXLkc",
        alt_text: "image_2",
        link: "linkExample",
        is_blank: "0",
        order: 2,
    },
    {

        image: "https://acortar.link/Cjon1G",

        image_responsive: "https://acortar.link/QJXLkc",
        alt_text: "image_3",
        link: "linkExample",
        is_blank: "0",
        order: 3,
    }
]


export const _contacts: Contact[] = [
    {
        name: "celular",
        aboutUs: "About us text",
        offer: "Special offer",
        phone: "123-456-7890",
        email: "example@email.com",
        facebook: "https://facebook.com/example",
        linkedin: "https://linkedin.com/example",
        youtube: "https://youtube.com/example",
        instagram: "https://instagram.com/example",
        metaDescription: "Meta description example",
        metaKeywords: "meta, keywords, example"
    }
]
export const _news: News[] = [
    {
        id: 2,
        image: "/images/image_slider.png",
        title: "title 1",
        description: "imagen ",
        date: "12 Agust 2024",
        slug: "title-2",
        categorySlug: "category-1"
    },
    {
        id: 2,
        image: "/images/image_slider.png",
        title: "title 2",
        description: "imagen ",
        date: "12 Agust 2024",
        slug: "title-2",
        categorySlug: "category-1"
    },
    {
        id: 3,
        image: "/images/image_slider.png",
        title: "title 3",
        description: "imagen ",
        date: "12 Agust 2024",
        slug: "title-3",
        categorySlug: "category-1"
    },
    {
        id: 4,
        image: "/images/image_slider.png",
        title: "title 4",
        description: "imagen ",
        date: "12 Agust 2024",
        slug: "title-4",
        categorySlug: "category-1"
    },

]


export const _promotions: Promotion[] = [
    {
        id: 1,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-11-01",
        endDate: "2024-11-15",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 1,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 2,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-12-01",
        endDate: "2024-12-15",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 2,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 3,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 3,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 4,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 4,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 5,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 5,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 6,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 6,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 7,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 7,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 8,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 8,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 9,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 9,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 10,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 10,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 11,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 11,
        media: "",
        fullImage: "",
        fullMedia: ""
    },
    {
        id: 12,
        image: "/images/promotions/image.svg",
        title: "Aprovecha las increíbles ofertas del mes de octubre en equipo usado",
        subtitle: "",
        startDate: "2024-10-01",
        endDate: "2024-10-31",
        hideDate: 0,
        extraPeriod: "",
        link: "",
        isBlank: "0",
        slug: "",
        order: 12,
        media: "",
        fullImage: "",
        fullMedia: ""
    }
];


export const _menus: Menu[] = [
    {
        name: "Equipo Nuevo",
        slug: "industrias",
        industries: [
            {
                title: "Quisquam recusandae qui provident sit saepe.",
                slug: "quisquam-recusandae-qui-provident-sit-saepe",
                families: [
                    {
                        title: "Acopladores",
                        slug: "Acopladores"
                    }
                ]
            }
        ],
        parts_services: [
            {
                title: "Sed est aut soluta totam voluptas laudantium occaecati.",
                slug: "sed-est-aut-soluta-totam-voluptas-laudantium-occaecati",
            }
        ]

    },
    {
        name: "Equipo Nuevo",
        slug: "industrias",
        parts_services: [
            {
                title: "atque fugit totam",
                slug: "veniam-iure-autem-quia"
            },
            {
                title: "cupiditate dolore rerum",
                slug: "iure-libero-aut-nesciunt"
            },
            {
                title: "explicabo earum sint",
                slug: "magnam-soluta-eligendi"
            },
        ]

    },
    {
        name: "Llantas",
        slug: "llantas",
        tires_industries: [
            {
                title: "Construcción",
                slug: "construccion",
                tires: [{
                    title: "Quia explicabo Obca",
                    slug: "quia-explicabo-obca"
                }
                ]
            },
            {
                title: "Minería",
                slug: "mineria",
                tires: [{
                    title: "Quia explicabo Obca",
                    slug: "quia-explicabo-obca"
                }
                ]
            },
            {
                title: "Marino",
                slug: "marino",
                tires: [{
                    title: "Quia explicabo Obca",
                    slug: "quia-explicabo-obca"
                }
                ]
            }
        ]
    },
    {
        name: "Soluciones y Tecnologia",
        slug: "soluciones-y-tecnologia",
        technological_solutions: [
            {
                title: "Doloremque molestiae a saepe quod ea qui dolore. Reiciendis vel in sit.",
                slug: "velit-velit-molestias-et-recusandae-et-similique-aliquid"
            },
            {
                title: "Molestias quod quis qui ipsum. Earum magnam ipsa recusandae quia id et eligendi.",
                slug: "facere-alias-quas-sed-saepe"
            },
            {
                title: "Sint assumenda consequatur et impedit. Nulla aspernatur quia sapiente sint et.",
                slug: "earum-voluptatem-neque-ea-similique"
            },
            {
                title: "Architecto ut adipisci eaque expedita non. Aut similique quis officia id quo et laboriosam.",
                slug: "autem-nihil-quaerat-incidunt-quae-dignissimos-eos-doloribus-atque"
            },
            {
                title: "Facilis corporis ea quam rerum et nobis non. Ipsa vel qui ipsa.",
                slug: "cumque-blanditiis-est-eligendi-consequatur-quis-ducimus-quod"
            }
        ]
    },
    {
        name: "Promociones",
        slug: "promociones",
        promotions: [
            {
                title: "Inventore officiis aperiam nulla dignissimos qui praesentium et.",
                slug: "illum-optio-nulla-in-necessitatibus-nulla-voluptas-est"
            },
            {
                title: "Nihil qui molestiae enim dignissimos dolores rem reprehenderit.",
                slug: "doloribus-repellendus-rerum-quia-sunt-eum-aut-aperiam-eveniet"
            },
            {
                title: "Modi rerum quasi autem doloremque.",
                slug: "est-soluta-rem-molestias-sint-vel"
            },
            {
                title: "Quisquam pariatur eum quo hic explicabo possimus odio.",
                slug: "modi-voluptatem-dolorem-blanditiis-natus-aut-voluptatem"
            },
            {
                title: "Qui ea laboriosam asperiores et quod.",
                slug: "voluptatem-veniam-magnam-nisi-molestias-non-impedit"
            },
            {
                title: "Et numquam ut sed maxime officiis dolore quos.",
                slug: "iure-qui-commodi-qui-possimus-iste-suscipit"
            },
            {
                title: "Et odit ad pariatur nesciunt.",
                slug: "itaque-quod-ea-consequatur-natus-provident-fugit-quae"
            }
        ]
    },
    {
        name: "Marcas",
        slug: "marcas",
        brands: [
            {
                title: "CAT",
                slug: "cat"
            }
        ]
    }

]